var map = {
	"./3dots.svg": "./src/drc/assets/icons/3dots.svg",
	"./Global-dark.svg": "./src/drc/assets/icons/Global-dark.svg",
	"./Global.svg": "./src/drc/assets/icons/Global.svg",
	"./activate.svg": "./src/drc/assets/icons/activate.svg",
	"./archive.svg": "./src/drc/assets/icons/archive.svg",
	"./arrow-down-blue.svg": "./src/drc/assets/icons/arrow-down-blue.svg",
	"./arrow-down-gray.svg": "./src/drc/assets/icons/arrow-down-gray.svg",
	"./arrow-down-white.svg": "./src/drc/assets/icons/arrow-down-white.svg",
	"./arrows/arrow-down-gray.svg": "./src/drc/assets/icons/arrows/arrow-down-gray.svg",
	"./arrows/arrow-down-white.svg": "./src/drc/assets/icons/arrows/arrow-down-white.svg",
	"./arrows/arrow-left-dark-white.svg": "./src/drc/assets/icons/arrows/arrow-left-dark-white.svg",
	"./arrows/arrow-left.svg": "./src/drc/assets/icons/arrows/arrow-left.svg",
	"./arrows/arrow-right.svg": "./src/drc/assets/icons/arrows/arrow-right.svg",
	"./arrows/arrow-top-right.svg": "./src/drc/assets/icons/arrows/arrow-top-right.svg",
	"./arrows/arrow-up-right.svg": "./src/drc/assets/icons/arrows/arrow-up-right.svg",
	"./arrows/arrow_right_alt.svg": "./src/drc/assets/icons/arrows/arrow_right_alt.svg",
	"./arrows/arrow_right_alt_black.svg": "./src/drc/assets/icons/arrows/arrow_right_alt_black.svg",
	"./arrows/arrow_right_blue.svg": "./src/drc/assets/icons/arrows/arrow_right_blue.svg",
	"./arrows/back-draft.svg": "./src/drc/assets/icons/arrows/back-draft.svg",
	"./arrows/blue-arrow-left.svg": "./src/drc/assets/icons/arrows/blue-arrow-left.svg",
	"./arrows/dark-arrow-left.svg": "./src/drc/assets/icons/arrows/dark-arrow-left.svg",
	"./arrows/dark-arrow-right.svg": "./src/drc/assets/icons/arrows/dark-arrow-right.svg",
	"./arrows/view-arrow.svg": "./src/drc/assets/icons/arrows/view-arrow.svg",
	"./audit.svg": "./src/drc/assets/icons/audit.svg",
	"./calendar-logo.svg": "./src/drc/assets/icons/calendar-logo.svg",
	"./calendar-project.svg": "./src/drc/assets/icons/calendar-project.svg",
	"./calendar.svg": "./src/drc/assets/icons/calendar.svg",
	"./cancel.svg": "./src/drc/assets/icons/cancel.svg",
	"./check-circle.svg": "./src/drc/assets/icons/check-circle.svg",
	"./check-green.svg": "./src/drc/assets/icons/check-green.svg",
	"./check-valid.svg": "./src/drc/assets/icons/check-valid.svg",
	"./check-yellow.svg": "./src/drc/assets/icons/check-yellow.svg",
	"./check.svg": "./src/drc/assets/icons/check.svg",
	"./check2.svg": "./src/drc/assets/icons/check2.svg",
	"./checked-circle.svg": "./src/drc/assets/icons/checked-circle.svg",
	"./circle-arrow.svg": "./src/drc/assets/icons/circle-arrow.svg",
	"./clock-project.svg": "./src/drc/assets/icons/clock-project.svg",
	"./close-search.svg": "./src/drc/assets/icons/close-search.svg",
	"./close.svg": "./src/drc/assets/icons/close.svg",
	"./copy-to-clipboard.svg": "./src/drc/assets/icons/copy-to-clipboard.svg",
	"./corner-icon.svg": "./src/drc/assets/icons/corner-icon.svg",
	"./delete.svg": "./src/drc/assets/icons/delete.svg",
	"./dislike.svg": "./src/drc/assets/icons/dislike.svg",
	"./dots.svg": "./src/drc/assets/icons/dots.svg",
	"./download.svg": "./src/drc/assets/icons/download.svg",
	"./edit-blue.svg": "./src/drc/assets/icons/edit-blue.svg",
	"./edit-check.svg": "./src/drc/assets/icons/edit-check.svg",
	"./edit-green.svg": "./src/drc/assets/icons/edit-green.svg",
	"./edit.svg": "./src/drc/assets/icons/edit.svg",
	"./error.svg": "./src/drc/assets/icons/error.svg",
	"./export.svg": "./src/drc/assets/icons/export.svg",
	"./eye-logo.svg": "./src/drc/assets/icons/eye-logo.svg",
	"./filter-close.svg": "./src/drc/assets/icons/filter-close.svg",
	"./filter-icon.svg": "./src/drc/assets/icons/filter-icon.svg",
	"./filter.svg": "./src/drc/assets/icons/filter.svg",
	"./filters/businessContactManagers.svg": "./src/drc/assets/icons/filters/businessContactManagers.svg",
	"./filters/certificates.svg": "./src/drc/assets/icons/filters/certificates.svg",
	"./filters/clientCountries.svg": "./src/drc/assets/icons/filters/clientCountries.svg",
	"./filters/companies.svg": "./src/drc/assets/icons/filters/companies.svg",
	"./filters/confidentialities.svg": "./src/drc/assets/icons/filters/confidentialities.svg",
	"./filters/deliveryContactManagers.svg": "./src/drc/assets/icons/filters/deliveryContactManagers.svg",
	"./filters/deliveryLocations.svg": "./src/drc/assets/icons/filters/deliveryLocations.svg",
	"./filters/ftes.svg": "./src/drc/assets/icons/filters/ftes.svg",
	"./filters/industries.svg": "./src/drc/assets/icons/filters/industries.svg",
	"./filters/publicationDates.svg": "./src/drc/assets/icons/filters/publicationDates.svg",
	"./filters/referenceOwners.svg": "./src/drc/assets/icons/filters/referenceOwners.svg",
	"./filters/revenues.svg": "./src/drc/assets/icons/filters/revenues.svg",
	"./filters/serviceLines.svg": "./src/drc/assets/icons/filters/serviceLines.svg",
	"./filters/techPractices.svg": "./src/drc/assets/icons/filters/techPractices.svg",
	"./filters/tools.svg": "./src/drc/assets/icons/filters/tools.svg",
	"./folder.svg": "./src/drc/assets/icons/folder.svg",
	"./fte-project.svg": "./src/drc/assets/icons/fte-project.svg",
	"./grid-view.svg": "./src/drc/assets/icons/grid-view.svg",
	"./hammer-white.svg": "./src/drc/assets/icons/hammer-white.svg",
	"./hammer.svg": "./src/drc/assets/icons/hammer.svg",
	"./help.svg": "./src/drc/assets/icons/help.svg",
	"./history.svg": "./src/drc/assets/icons/history.svg",
	"./home.svg": "./src/drc/assets/icons/home.svg",
	"./image-upload-black.svg": "./src/drc/assets/icons/image-upload-black.svg",
	"./image-upload.svg": "./src/drc/assets/icons/image-upload.svg",
	"./info.svg": "./src/drc/assets/icons/info.svg",
	"./information.svg": "./src/drc/assets/icons/information.svg",
	"./insert_drive_file.svg": "./src/drc/assets/icons/insert_drive_file.svg",
	"./like.svg": "./src/drc/assets/icons/like.svg",
	"./link.svg": "./src/drc/assets/icons/link.svg",
	"./list-view.svg": "./src/drc/assets/icons/list-view.svg",
	"./manager.svg": "./src/drc/assets/icons/manager.svg",
	"./money-project.svg": "./src/drc/assets/icons/money-project.svg",
	"./nested.svg": "./src/drc/assets/icons/nested.svg",
	"./no-content.svg": "./src/drc/assets/icons/no-content.svg",
	"./owner.svg": "./src/drc/assets/icons/owner.svg",
	"./pen-white.svg": "./src/drc/assets/icons/pen-white.svg",
	"./pen-yellow.svg": "./src/drc/assets/icons/pen-yellow.svg",
	"./pen.svg": "./src/drc/assets/icons/pen.svg",
	"./pending.svg": "./src/drc/assets/icons/pending.svg",
	"./picture_as_pdf.svg": "./src/drc/assets/icons/picture_as_pdf.svg",
	"./play.svg": "./src/drc/assets/icons/play.svg",
	"./plus-gray.svg": "./src/drc/assets/icons/plus-gray.svg",
	"./plus-in-circle.svg": "./src/drc/assets/icons/plus-in-circle.svg",
	"./plus.svg": "./src/drc/assets/icons/plus.svg",
	"./preview.svg": "./src/drc/assets/icons/preview.svg",
	"./published.svg": "./src/drc/assets/icons/published.svg",
	"./quotation-marks.svg": "./src/drc/assets/icons/quotation-marks.svg",
	"./report-problem.svg": "./src/drc/assets/icons/report-problem.svg",
	"./report-problem2.svg": "./src/drc/assets/icons/report-problem2.svg",
	"./resources.svg": "./src/drc/assets/icons/resources.svg",
	"./save-blue.svg": "./src/drc/assets/icons/save-blue.svg",
	"./save-draft.svg": "./src/drc/assets/icons/save-draft.svg",
	"./save-white.svg": "./src/drc/assets/icons/save-white.svg",
	"./save.svg": "./src/drc/assets/icons/save.svg",
	"./saved.svg": "./src/drc/assets/icons/saved.svg",
	"./search-glass.svg": "./src/drc/assets/icons/search-glass.svg",
	"./search.svg": "./src/drc/assets/icons/search.svg",
	"./search_big.svg": "./src/drc/assets/icons/search_big.svg",
	"./start-paly.svg": "./src/drc/assets/icons/start-paly.svg",
	"./stop.svg": "./src/drc/assets/icons/stop.svg",
	"./success.svg": "./src/drc/assets/icons/success.svg",
	"./time.svg": "./src/drc/assets/icons/time.svg",
	"./trash-white.svg": "./src/drc/assets/icons/trash-white.svg",
	"./trash.svg": "./src/drc/assets/icons/trash.svg",
	"./triangle-down.svg": "./src/drc/assets/icons/triangle-down.svg",
	"./upload.svg": "./src/drc/assets/icons/upload.svg",
	"./user.svg": "./src/drc/assets/icons/user.svg",
	"./users.svg": "./src/drc/assets/icons/users.svg",
	"./warning.svg": "./src/drc/assets/icons/warning.svg",
	"./x-red.svg": "./src/drc/assets/icons/x-red.svg",
	"./x-with-cicle.svg": "./src/drc/assets/icons/x-with-cicle.svg",
	"./x_black.svg": "./src/drc/assets/icons/x_black.svg",
	"./x_white.svg": "./src/drc/assets/icons/x_white.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/drc/assets/icons sync recursive ^\\.\\/.*\\.svg$";